import * as Actions from './Actions';
import { PHONE_VERIFICATION_MODE, PhoneVerificationErrors } from './constants';

const defaultState = {
    viewMode: PHONE_VERIFICATION_MODE.ENTRY_MODE,
    phoneNumberError: null,
    phoneNumberFormatted: undefined,
    pin: '',
    sendingPin: false,
    sendPinFailure: false,
    verifyingPin: false,
    pinVerified: false,
    verifyPinError: null,
};

export const phoneVerificationPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case Actions.PhoneVerificationPageActions.CHANGE_PHONE_NUMBER: {
            return {
                ...state,
                phoneNumberFormatted: action.phoneNumber,
                phoneNumberError: null,
            };
        }

        case Actions.PhoneVerificationPageActions.SENDING_PIN: {
            return {
                ...state,
                sendingPin: true,
            };
        }

        case Actions.PhoneVerificationPageActions.SENDING_PIN_SUCCESS: {
            return {
                ...state,
                sendingPin: false,
                viewMode: PHONE_VERIFICATION_MODE.VERIFY_MODE,
            };
        }

        case Actions.PhoneVerificationPageActions.SENDING_PIN_FAILURE: {
            return {
                ...state,
                sendingPin: false,
                sendPinFailure: true,
                phoneNumberError: PhoneVerificationErrors.InvalidPhoneNumber,
            };
        }

        case Actions.PhoneVerificationPageActions.NO_VERIFICATION_NEEDED: {
            return {
                ...state,
                sendingPin: false,
                phoneNumberError: PhoneVerificationErrors.PhoneAlreadyVerified,
            };
        }

        case Actions.PhoneVerificationPageActions.EDIT_PHONE_NUMBER: {
            return {
                ...state,
                viewMode: PHONE_VERIFICATION_MODE.ENTRY_MODE,
            };
        }

        case Actions.PhoneVerificationPageActions.CHANGE_PIN: {
            return {
                ...state,
                pin: action.pin,
            };
        }

        case Actions.PhoneVerificationPageActions.VERIFYING_PIN: {
            return {
                ...state,
                verifyingPin: true,
                verifyPinError: false,
            };
        }

        case Actions.PhoneVerificationPageActions.VERIFY_PIN_SUCCESS: {
            return {
                ...state,
                verifyingPin: false,
                pinVerified: true,
            };
        }

        case Actions.PhoneVerificationPageActions.VERIFY_PIN_FAILURE: {
            return {
                ...state,
                verifyingPin: false,
                verifyPinError: action.error,
            };
        }

        case Actions.PhoneVerificationPageActions.RESET: {
            return {
                ...defaultState,
            };
        }

        default:
            return state;
    }
};
